import React from "react";
import { AiOutlineInfoCircle, AiOutlineSearch } from "react-icons/ai";

import Chart from "components/MI/minha-conta/Chart";
import CodeVerification from "components/MI/minha-conta/CodeVerification";
import ContainedButton from "components/layout/form/containedButton";
import Loading from "components/layout/loading";
import Form from "components/MI/minha-conta/Form";
import ModalBill from "components/MI/minha-conta/ModalBill";
import ModalInfo from "components/MI/minha-conta/ModalInfo";
import ModalValidationContacts from "components/MI/minha-conta/ModalValidationContacts";
import Navbar from "components/MI/Navbar";
import NotFoundBills from "components/MI/minha-conta/NotFoundBills";
import TourBalloon from "components/NewTour/TourBallon";
import UserMenu from "components/layout/userMenuNew";

import { useConsumoPage } from "../hooks/useConsumoPage";
import {
  Body,
  Button,
  Container,
  Content,
  ContentCode,
  ContentInfos,
  ContentLeft,
  ContentResult,
  ContentRight,
  ContentSubtitle,
  ContentTexts,
  ContentTitle,
  ContentWrap,
  Header,
  HeaderInfos,
  HeaderSubtitle,
  HeaderTitle,
} from "../styles";

const ConsumoPage = (): JSX.Element => {
  const {
    status,
    billsFormatted,
    firstBill,
    code,
    openModalInfo,
    openModalBill,
    openModalValidation,
    statusCalc,
    showForm,
    months,
    contacts,
    protocol,
    showTour,
    tourStep,
    tourType,
    toggleModalInfo,
    toggleModalBill,
    toggleModalValidation,
    onChangeCode,
    calculateKg,
    openForm,
    handleSubmit,
    requestGetUserContacts,
  } = useConsumoPage();

  return (
    <>
      <Navbar selected="consumo" openSubMenu>
        <UserMenu intro />
        <Container>
          <Header>
            <HeaderInfos>
              <HeaderTitle>Consumo</HeaderTitle>
              <HeaderSubtitle>
                Aqui você encontra todos consumos dos últimos 12 meses!
              </HeaderSubtitle>
            </HeaderInfos>
            <ContentWrap
              showTour={tourStep === 3 && tourType === "consumo" && showTour}
            >
              <Button
                target="_blank"
                to={{
                  pathname: "https://www.ultragaz.com.br/entenda-sua-conta/",
                }}
              >
                Entenda a conta
              </Button>
              {showTour && tourStep === 3 && tourType === "consumo" && (
                <TourBalloon
                  title="Entenda sua conta"
                  content="Saiba como é calculada sua conta de gás"
                  position={{
                    left: "-120px",
                    top: "30px",
                    arrowPosition: "top",
                    arrowTop: "-27%",
                    maxWidth: 320,
                  }}
                />
              )}
            </ContentWrap>
          </Header>
          <Body>
            {billsFormatted?.length > 0 ? (
              <Content>
                <ContentWrap
                  showTour={
                    tourStep === 1 && tourType === "consumo" && showTour
                  }
                >
                  <ContentLeft>
                    <ContentTitle align="center">
                      Histórico de consumo - Volume (Kg)
                    </ContentTitle>
                    <Chart data={billsFormatted} />
                  </ContentLeft>
                  {showTour && tourStep === 1 && tourType === "consumo" && (
                    <TourBalloon
                      title="Consumo"
                      content="Encontre aqui seu histórico de consumo (em Kg) nos últimos 12 meses!"
                      position={{
                        left: "446px",
                        top: "0",
                        arrowPosition: "left",
                        arrowLeft: "-10%",
                        maxWidth: 320,
                        boxShadow: true,
                      }}
                    />
                  )}
                </ContentWrap>
                <ContentWrap
                  showTour={
                    tourStep === 2 && tourType === "consumo" && showTour
                  }
                >
                  <ContentRight>
                    <ContentTitle align="start">Ainda com dúvida?</ContentTitle>
                    <ContentInfos>
                      <ContentTexts>
                        <ContentSubtitle>
                          Inclua aqui a leitura atual do seu medidor,
                          considerando os zeros.
                        </ContentSubtitle>
                      </ContentTexts>
                      <AiOutlineInfoCircle onClick={toggleModalInfo} />
                    </ContentInfos>
                    <ContentCode>
                      <CodeVerification
                        onChange={(e) => onChangeCode(e)}
                        value={code?.value}
                        error={code?.error}
                        calculateKg={calculateKg}
                      />
                    </ContentCode>
                    <ContentInfos>
                      <ContentTexts>
                        <ContentSubtitle>
                          *Se a leitura atual do medidor for menor do que a
                          última leitura registrada no seu boleto, pode haver
                          divergência.
                        </ContentSubtitle>
                        <ContentSubtitle>
                          {`Sua última leitura foi de: `}
                          <strong>{firstBill?.finalMeasurement}</strong>
                        </ContentSubtitle>
                      </ContentTexts>
                      <AiOutlineInfoCircle onClick={toggleModalBill} />
                    </ContentInfos>
                    {statusCalc === "success" && (
                      <div>
                        <ContentResult success>
                          <AiOutlineSearch />
                          <p>
                            A leitura atual é maior ou igual à leitura anterior,
                            o que indica que a leitura foi feita corretamente e
                            que seu medidor está funcionando normalmente.
                          </p>
                        </ContentResult>
                        {!showForm && (
                          <ContainedButton
                            name="solicitar-analise"
                            id="solicitar-analise"
                            onClick={openForm}
                          >
                            Ainda quero solicitar uma análise mais profunda
                          </ContainedButton>
                        )}
                      </div>
                    )}
                    {statusCalc === "error" && (
                      <ContentResult success={false}>
                        <AiOutlineSearch />
                        <p>
                          Por favor, preencha as informações abaixo para que
                          possamos avaliar o que aconteceu.
                        </p>
                      </ContentResult>
                    )}
                    {showForm && (
                      <div>
                        <ContentTitle align="start">
                          Deseja solicitar uma análise mais profunda por parte
                          da Ultragaz?
                        </ContentTitle>
                        <Form handleSubmit={handleSubmit} months={months} />
                      </div>
                    )}
                  </ContentRight>
                  {showTour && tourStep === 2 && tourType === "consumo" && (
                    <TourBalloon
                      title="Contestação"
                      content="Informe aqui a leitura atual do seu medidor, caso deseje solicitar uma análise de leitura."
                      position={{
                        left: "442px",
                        top: "0",
                        arrowPosition: "left",
                        arrowLeft: "-10%",
                        maxWidth: 320,
                        boxShadow: true,
                      }}
                    />
                  )}
                </ContentWrap>
              </Content>
            ) : (
              <NotFoundBills />
            )}
          </Body>
        </Container>
      </Navbar>

      <ModalInfo open={openModalInfo} toggleModal={toggleModalInfo} />
      <ModalBill open={openModalBill} toggleModal={toggleModalBill} />
      <ModalValidationContacts
        open={openModalValidation}
        toggleModal={toggleModalValidation}
        contacts={contacts}
        protocol={protocol}
        getContacts={requestGetUserContacts}
      />
      {status === "loading" && <Loading />}
    </>
  );
};

export default ConsumoPage;
